import { apiCall } from "../../services/api-service.js";

export const getVendorHistoryListApi = async (params) => {
    try {
        const response = await apiCall("get", "vendor_histories", null, {
            params,
        });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    }
};

export const exportVendorHistoryApi = async (params) => {
    try {
        const response = await apiCall("get", "vendor_histories/export", null, {
            params,
        });
        return response;
    } catch (err) {
        console.error("Error exporting vendor history:", err);
    }
};